<template>
  <div class="modal-content">

    <div class="modal-header">
      <button type="button"
              class="close"
              @click="closeModal"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
      <h4 class="modal-title">Ajouter un acheteur</h4>
    </div>
    <div class="modal-body">
      <component-alert v-if="hasError && errors.any()"
                       type="danger"
                       label="Certaines informations sont manquantes ou erronées."/>
      <div class="wrapper">
        <div class="row">
          <div class="col-lg-12">
            <h3 class="text-center">Chercher un client existant</h3>
            <div class="row m-t-md">
              <div class="col-lg-12">
                <div class="form-group">
                  <label class="control-label" style="position: relative;">Par Prénom et nom du client
                    <input type="text"
                           placeholder="Prénom et nom du client"
                           class="form-control"
                           @focus="showAutoComplete = true"
                           @blur="hideAutoComplete"
                           v-model="fullName">
                    <ul v-if="showAutoComplete && customer.length"
                        class="typeahead dropdown-menu"
                        style="display: block;">
                      <li v-for="(item, index) in customer"
                          :key="index">
                        <a class="dropdown-item"
                           @click.prevent.stop="assignCustomer(item)">{{ item.firstname + ' ' + item.lastname }}</a>
                      </li>
                    </ul>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <spinner-three-bounce :displayNone="!$apollo.queries.customer.loading || skipQuery"/>

        <div class="row m-t-md">
          <div class="col-lg-12">
            <h3 class="text-center">Ajouter un client</h3>
            <div class="row m-t-md">
              <div class="col-lg-6">
                <div class="form-group"
                     :class="{'has-error': errors.has('first_name')}">
                  <label class="control-label">Prénom
                    <input type="text"
                           placeholder="Prénom"
                           class="form-control"
                           name="first_name"
                           v-model="newCustomer.firstname"
                           v-validate="'required'">
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group"
                     :class="{'has-error': errors.has('last_name')}">
                  <label class="control-label">Nom
                    <input type="text"
                           placeholder="Nom"
                           class="form-control"
                           name="last_name"
                           v-model="newCustomer.lastname"
                           v-validate="'required'">
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group"
                     :class="{'has-error': errors.has('email')}">
                  <label class="control-label">Email
                    <input type="text"
                           placeholder="Email"
                           class="form-control"
                           name="email"
                           v-model="newCustomer.email"
                           v-validate="'required|email'">
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="control-label">Fixe (optionnel)
                    <input type="text"
                           placeholder="ex: 0189898989"
                           class="form-control"
                           name="fixe"
                           maxlength=10
                           @keyup="onKeyupPhoneFixeNumber"
                           v-model="newCustomer.fix">
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group"
                     :class="{'has-error': errors.has('portable')}">
                  <label class="control-label">Portable
                    <input type="text"
                           placeholder="ex: 0789898989"
                           class="form-control"
                           name="portable"
                           maxlength=10
                           @keyup="onKeyupPhonePortableNumber"
                           v-model="newCustomer.phone">
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group"
                     :class="{'has-error': !hasAddress && formSubmitted}">
                  <label class="control-label">Adresse
                    <gmap-autocomplete ref="gmapAutocomplete"
                                       :componentRestrictions="{'country': ['fr']}"
                                       placeholder="Adresse"
                                       class="form-control"
                                       name="address"
                                       @change="newCustomer.address.address = newCustomer.address.zipCode = newCustomer.address.city = ''"
                                       @place_changed="onClickPlace"/>
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group"
                     :class="{'has-error': !hasZipcode && formSubmitted}">
                  <label class="control-label">Code postal
                    <input type="text"
                           placeholder="Code postal"
                           class="form-control"
                           name="zipcode"
                           v-model="newCustomer.address.zipCode"
                           v-validate="'required'"
                           readonly>
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group"
                     :class="{'has-error': !hasCity && formSubmitted}">
                  <label class="control-label">Ville
                    <input type="text"
                           placeholder="Ville"
                           class="form-control"
                           name="city"
                           v-model="newCustomer.address.city"
                           v-validate="'required'"
                           readonly>
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group"
                     :class="{'has-error': errors.has('organization')}">
                  <label class="control-label">Assureur</label>
                  <div class="row">
                    <div class="col-sm-12">
                      <select id="organization" 
                              class="form-control"
                              v-model="newCustomer.organization"
                              v-validate="'required'"
                              name="organization"
                      >
                        <option :value="4">Maif</option>
                        <option :value="1">Macif</option>
                        <option :value="2">Matmut</option>
                        <option :value="3">AMF Assurances</option>
                        <option :value="0">Aucun</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group"
                     :class="{'has-error': errors.has('companyName')}">
                  <label class="control-label">Société
                    <input type="text"
                           placeholder="Société"
                           class="form-control"
                           name="companyName"
                           v-model="newCustomer.companyName"
                           v-validate="'min:2'">
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group"
                     :class="{'has-error': !hasPartnerLead && formSubmitted}">
                  <label class="control-label">Où le client a-t-il découvert cette annonce ?</label>
                  <div class="row">
                    <div class="col-sm-12">
                      <select id="partnerLead"
                              class="form-control"
                              v-model="newCustomer.partnerLeadSelected"
                              v-validate="'required'"
                              name="partnerSelected"
                      >
                        <option v-for="item in partnerLeadList.response" v-bind:value="item.id">
                        {{item.label}}
                        </option><br>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group"
                     :class="{'has-error': errors.has('birthDate')}">
                  <label class="control-label">Date de naissance
                    <input type="date"
                           placeholder="Date de naissance"
                           class="form-control"
                           name="birthDate"
                           v-model="newCustomer.birthDate" />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button"
              class="btn"
              @click="closeModal">Annuler</button>
      <button type="button"
              class="btn btn-primary"
              @click="onSubmit">Ajouter cet acheteur</button>
    </div>

  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import Alert from '../Alert.vue'
  import { formatAddress } from '../../helpers/utils'
  import store from '../../config/store'
  import SpinnerThreeBounce from '@/components/spinners/SpinnerThreeBounce'

  export default {
    components: {
      'component-alert': Alert,
      SpinnerThreeBounce
    },

    data: () => ({
      fullName: '',
      customer: [],
      newCustomer: {
        address: {},
        organization: 0,
        partnerLeadSelected: 0,
        coordinate: {
          latitude: null,
          longitude: null,
        },
        phone: null,
        fix: null,
      },
      partnerLeadList: {response: []},
      showAutoComplete: false,
      gmapsAutoComplete: '',
      skipQuery: true,
      hasError: false,
      formSubmitted: false
    }),

    computed: {
      customerQuery () {
        return gql`query {
          customer ( fullName: "${this.fullName}", limit: 10){
            id
            firstname
            lastname
            birthDate
            email
            phone
            address {
              address
              zipCode
              city
            }
            coordinate {
              latitude
              longitude
            }
            organization
            companyName
          }
        }`
      },

      partnerLeadQuery () {
        return gql`query {
          partnerLeadList : getPartnerLead {
           response {
            id
            label
           }
          }
        }`
      },

      hasAddress () {
        return this.newCustomer.address.address
      },

      hasZipcode () {
        return this.newCustomer.address.zipCode
      },

      hasCity () {
        return this.newCustomer.address.city
      },

      buyer () {
        return store.modal.dataModel
      },

      hasPartnerLead () {
        if (this.newCustomer.partnerLeadSelected != 0) {
          return true
        }
        return false
      }
    },

    watch: {
      fullName () {
        if (this.fullName.length < 3) {
          this.skipQuery = true
          this.customer = []
        } else {
          this.skipQuery = false
          this.$apollo.queries.customer.refetch()
        }
      },
      customer () {
        if(
          (!this.customer || this.customer.length === 0) &&
          this.fullName.length > 2
        ){
          this.showBanner('danger', "Ce client n'est pas connu de nos services.")
        }   
      }
    },

    mounted () {
      if (this.buyer) {
        this.assignCustomer(this.buyer)
      }
    },

    methods: {
      onKeyupPhonePortableNumber(event) {
        if (event.key === "Backspace") {
          return
        }

        let formattedPhoneNumber = null;
        formattedPhoneNumber = this.newCustomer.phone.toUpperCase();
        this.newCustomer.phone = formattedPhoneNumber.replace(/\s/, '').replace(/[a-zA-Z]/, '');
      },
      onKeyupPhoneFixeNumber(event) {
        if (event.key === "Backspace") {
          return
        }

        let formattedPhoneNumber = null;
        formattedPhoneNumber = this.newCustomer.fix.toUpperCase();
        this.newCustomer.fix = formattedPhoneNumber.replace(/\s/, '').replace(/[a-zA-Z]/, '');
      },
      hideAutoComplete () {
        setTimeout(() => {
          this.showAutoComplete = false
        }, 100)
      },

      assignCustomer (customer) {
        this.fullName = customer.firstname + ' ' + customer.lastname
        this.newCustomer = { ...customer }
        this.$refs.gmapAutocomplete.$el.value = this.newCustomer.address.address
        this.showAutoComplete = false
      },

      onClickPlace (place) {
        this.newCustomer.address = {}
        this.newCustomer.coordinate = {}
        this.newCustomer.address = formatAddress(place)
        this.newCustomer.coordinate.latitude = place.geometry.location.lat();
        this.newCustomer.coordinate.longitude = place.geometry.location.lng();
        this.$refs.gmapAutocomplete.$el.value = this.newCustomer.address.address
      },

      onSubmit () {
        this.formSubmitted = true
        this.$validator.validateAll().then(result => {
          if (result && this.hasPartnerLead) {
            this.$bus.$emit('select-customer-success', this.newCustomer)
            this.closeModal()
          } else {
            this.hasError = true
          }
        })
      }
    },

    apollo: {
      customer: {
        query () {
          return this.customerQuery
        },
        skip () {
          return this.skipQuery
        }
      },
      partnerLeadList: {
          query() {
            return this.partnerLeadQuery
          }
      }
    }
  }
</script>
